module.exports = "/_next/static/images/heart-2-1-bdc6155bf857cc30650f8b640e3b729e.png";